// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ExFS","content":"styles_content__3z1mr","row":"styles_row__13gnV","footer":"styles_footer__2u6Et","phraseLength":"styles_phraseLength__3voQ4"};